import { Injector } from "@angular/core";
import { AppMessage } from './app-message.class';
import * as i0 from "@angular/core";
export let AppMessageFactory = /*#__PURE__*/(() => {
  class AppMessageFactory {
    constructor(injector) {
      this.injector = injector;
    }
    create(messageData = {}) {
      return new AppMessage(this.injector).setMessage(messageData);
    }
    static {
      this.ɵfac = function AppMessageFactory_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AppMessageFactory)(i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AppMessageFactory,
        factory: AppMessageFactory.ɵfac
      });
    }
  }
  return AppMessageFactory;
})();